import { ForgotPasswordForm } from '@components/auth/forgot-password-form';
import { BrandHeader } from '@components/brand-header';
import { Head } from '@components/head';
import { SimpleLayout } from '@components/ui/layouts/simple';
import { Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';

export const ForgotPasswordPage = () => {
  return (
    <SimpleLayout>
      <Head title="Forgot password" />
      <Grid container sx={{ minHeight: '100%' }}>
        <Grid
          xs={12}
          lg={12}
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Stack spacing={2} direction="column" width={400}>
            <BrandHeader />
            <Typography variant="h2">Reset Password</Typography>
            <ForgotPasswordForm />
          </Stack>
        </Grid>
      </Grid>
    </SimpleLayout>
  );
};
